import React, {useState} from "react";
import "./dashbaord.css";
const AnalysisOfAgedDebtors=()=>{
    return(
        <div className={"AnalysisOfAgedDebtors"}>
            <div>Analysis of Aged Debtors</div>
        </div>
    )
}
export default AnalysisOfAgedDebtors;